import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.18.0_@_924c109f4af11ef2e3b4c46ed1ca038b/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}